export function formatNumber(num: number | undefined | null): string {
  if (num === undefined || num === null) return '0'
  return num.toLocaleString()
}

export function formatPercent(num: number | undefined | null): string {
  if (num === undefined || num === null) return '0%'
  return `${num.toFixed(1)}%`
}

export function formatCompact(num: number | undefined | null): string {
  if (num === undefined || num === null) return '0'
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`
  return num.toString()
}
